(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Original theme JavaScript
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // StateRestrict: Set cart attribute for state from URL
  document.addEventListener('DOMContentLoaded', function() {
    var urlParams = new URLSearchParams(window.location.search);
    var urlState = urlParams.get('state');
    var serverState = '{{ customer_state }}';
    
    console.log('[StateRestrict] URL state:', urlState, 'Server state:', serverState);
    
    // If state is in URL but not on server, set cart attribute and reload
    if (urlState && serverState !== urlState) {
      console.log('[StateRestrict] Setting cart attribute for:', urlState);
      
      // Set cart attribute that Liquid can read
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'customer_state': urlState
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('[StateRestrict] Cart updated:', data.attributes);
        // Reload without query params
        window.location.href = window.location.pathname;
      })
      .catch(error => {
        console.error('[StateRestrict] Error setting cart attribute:', error);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var customerState = '{{ customer_state }}';
  var urlParams = new URLSearchParams(window.location.search);
  var urlState = urlParams.get('state');
  
  console.log('[StateRestrict Product List] Customer state:', customerState, 'URL state:', urlState);
  
  // If state is in URL but not on server, set cart attribute and reload
  if (urlState && customerState !== urlState) {
    console.log('[StateRestrict Product List] Setting cart attribute for:', urlState);
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'customer_state': urlState
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('[StateRestrict Product List] Cart updated:', data.attributes);
      // Reload without query params
      window.location.href = window.location.pathname;
    })
    .catch(error => {
      console.error('[StateRestrict Product List] Error setting cart attribute:', error);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  // StateRestrict: Set cart attribute for state from URL
  document.addEventListener('DOMContentLoaded', function() {
    var urlParams = new URLSearchParams(window.location.search);
    var urlState = urlParams.get('state');
    var serverState = '{{ customer_state }}';
    
    console.log('[StateRestrict] URL state:', urlState, 'Server state:', serverState);
    
    // If state is in URL but not on server, set cart attribute and reload
    if (urlState && serverState !== urlState) {
      console.log('[StateRestrict] Setting cart attribute for:', urlState);
      
      // Preserve the search query
      var searchQuery = urlParams.get('q');
      
      // Set cart attribute that Liquid can read
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'customer_state': urlState
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('[StateRestrict] Cart updated:', data.attributes);
        // Reload with search query but without state param
        var newUrl = window.location.pathname;
        if (searchQuery) {
          newUrl += '?q=' + encodeURIComponent(searchQuery);
        }
        window.location.href = newUrl;
      })
      .catch(error => {
        console.error('[StateRestrict] Error setting cart attribute:', error);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
